import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    marginBottom: 20,
    marginHorizontal: 10,
  },
  contentContainer: {
    backgroundColor: colors.white,
    borderRadius: 20,
    paddingHorizontal: 16,
    paddingVertical: 24,
  },
  contentTitle: { fontFamily: typography.primary.normal, fontSize: 18, marginBottom: 10 },
  headerContainer: { height: 135, width: "100%" },
  headerContentContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginLeft: 10,
    marginTop: 40,
  },
  headerTitle: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 16,
    marginLeft: 10,
  },
  megaphoneImage: { bottom: -20, height: 168, marginTop: 40, width: 168, zIndex: 999 },
  referralCodeContainer: {
    borderColor: colors.lighterGrey,
    borderRadius: 20,
    borderStyle: "dashed",
    borderWidth: 2,
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 10,
    padding: 20,
  },
  referralCodeText: { fontFamily: typography.primary.normal, marginRight: 10 },
  referralCodeWrapper: { alignItems: "center", flexDirection: "row" },
  shareLogo: { height: 48, width: 48 },
  shareLogoContainer: { flexDirection: "row", justifyContent: "space-around", marginTop: 20 },
  ball1: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.4,
    width: 100,
    height: 100,
    bottom: -20,
    left: -40,
  },
  ball2: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.2,
    width: 70,
    height: 70,
    bottom: 35,
    left: 40,
  },
  ball3: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.5,
    width: 130,
    height: 130,
    bottom: -50,
    right: -50,
  },
  ball4: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.3,
    width: 80,
    height: 80,
    bottom: 30,
    right: 40,
  },
  ball5: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.4,
    width: 90,
    height: 90,
    bottom: -50,
    left: 60,
  },
  ball6: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.3,
    width: 50,
    height: 50,
    bottom: -30,
    right: 120,
  },
  ball7: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.3,
    width: 75,
    height: 75,
    bottom: -15,
    right: 60,
  },
  ball8: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.3,
    width: 50,
    height: 50,
    bottom: -15,
    left: 40,
  },
})
